import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { FormsModule, FormGroup, FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { ValidationMessagesModule } from 'ng2-custom-validation';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { HttpModule } from '@angular/http';
import { LocalStorageService} from "angular2-localstorage";
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { PushNotificationsModule } from 'angular2-notifications'; 
import { StickyModule } from 'ng2-sticky-kit';
import { MyDatePickerModule } from 'mydatepicker';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { Ng2StickyModule } from 'ng2-sticky';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { LocationStrategy } from '@angular/common';
import {APP_BASE_HREF} from '@angular/common';
import { CustomlocationstrategyService } from "./customlocationstrategy.service";
import { NgxCarouselModule } from 'ngx-carousel';
 import { NguiAutoCompleteModule } from '@ngui/auto-complete';
//import { MetaModule } from 'ng2-meta';

import 'hammerjs';

import { AppComponent } from './app.component';
import { HeaderBarComponent } from './header-bar/header-bar.component';
import { FooterBarComponent } from './footer-bar/footer-bar.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import {ModalModule} from "ngx-modal";
import {TabsModule} from "ngx-tabs";
import { WebApiObservableService } from './web-api-observable/web-api-observable.service';
import { OrderOnlineComponent } from './order-online/order-online.component';
import { FoodServiceService } from './food-service.service';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { OrderPlacedComponent } from './order-placed/order-placed.component';
import { KittyPartyComponent } from './kitty-party/kitty-party.component';
import { TableReservationComponent } from './table-reservation/table-reservation.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { OrderViewComponent } from './order-view/order-view.component';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { AddressesComponent } from './addresses/addresses.component';
import { MessageComponent } from './message/message.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent,
   /*data: {
      meta: {
        title: 'Home',
        description: 'Description of the home page'
      }
    } */
  },
  { path: 'home', component: HomeComponent, 
  /*data: {
      meta: {
        title: 'Home',
        description: 'Description of the home page'
      }
    }*/
  },
  { path: 'about', component: AboutComponent},
  { path: 'contact', component: ContactComponent },
  { path: "order-online/:id", component: OrderOnlineComponent},
  { path: 'cart', component: CartComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'order-placed', component: OrderPlacedComponent },
  { path: 'kitty-party', component: KittyPartyComponent },
  { path: 'table-reservation', component: TableReservationComponent },
  { path: 'my-account', component: MyAccountComponent },
  { path: 'order-view/:id', component: OrderViewComponent },
  { path: 'edit-account', component: EditAccountComponent },
  { path: 'addresses', component: AddressesComponent },
  { path: 'message', component: MessageComponent }
];
@NgModule({
  declarations: [
    AppComponent,
    HeaderBarComponent,
    FooterBarComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    OrderOnlineComponent,
    CartComponent,
    CheckoutComponent,
    OrderPlacedComponent,
    KittyPartyComponent,
    TableReservationComponent,
    MyAccountComponent,
    OrderViewComponent,
    EditAccountComponent,
    AddressesComponent,
    MessageComponent    
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule,
    CustomFormsModule,
    ValidationMessagesModule.forRoot(),
    Ng2SearchPipeModule,
    Ng2FilterPipeModule,
    PushNotificationsModule,
    StickyModule,
    MyDatePickerModule,
    NgbModule.forRoot(),
    Ng2StickyModule,
    FlashMessagesModule,
    NgxCarouselModule,
    NguiAutoCompleteModule,
    //MetaModule.forRoot(),
    HttpModule,
    ModalModule,
    TabsModule
  ],
  providers: [WebApiObservableService,HeaderBarComponent,FoodServiceService,LocalStorageService,{provide: APP_BASE_HREF, useValue: window.location.pathname}, {provide: LocationStrategy, useClass: CustomlocationstrategyService}],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/app.module.ts